import { apiRequest } from "@core/services/api/apiRequest";
import { VIDEO_API } from "../videoMeeting.constants";
import type {
  JoinVideoRoomRequest,
  JoinVideoRoomResponse,
} from "../videoMeeting.types";
import { getTrackingMetadata } from "./getTrackingMetadata";

export const joinVideoMeetingApi = async (
  request: JoinVideoRoomRequest,
  user: { id: number } | null
): Promise<JoinVideoRoomResponse> => {
  const trackingMetadata = getTrackingMetadata(user);
  return apiRequest(VIDEO_API.JOIN_ROOM, "POST", {
    ...request,
    ...trackingMetadata,
  });
};
